import React, { Component, Fragment } from "react";
import { Pagination, Select, message } from "antd";
import Moment from "moment";
import Bounced from "../../components/bounced";
import {
  fetchAppealListData,
  fetchPageConfigData,
  revoke,
} from "../../services/services";
import { appealListType } from "../../utils/interfaceType";
import { getQueryString } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import appeal from "../../static/images/appeal.png";
import Prompt from "../../components/prompt";
import Loading from "../../components/loading";
import { withRouter } from "react-router-dom";
import styles from "./index.less";

interface State {
  caseStatus: string | number;
  appealListData: any[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  displayControl: any;
  modalType: boolean;
  caseId: any;
  error: boolean;
  loading: boolean;
  configLoading: boolean;
}
interface Props {
  history: any;
}

/**
 * @description 申诉状态
 *
 **/
const caseType = [
  {
    id: 1,
    name: "审核中",
  },
  {
    id: 2,
    name: "已撤诉",
  },
  {
    id: 3,
    name: "补充资料",
  },
  {
    id: 4,
    name: "已通过",
  },
  {
    id: 5,
    name: "已驳回",
  },
];

class AppealList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      caseStatus: "",
      appealListData: [{}],
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      displayControl: [],
      modalType: false,
      caseId: 0,
      error: false,
      loading: true,
      configLoading: true,
    };
  }

  async componentDidMount() {
    burying("1", "appeal-record-page", "undefined", "ss-04", "undefined");
    this.getPageConfigData();
    this.getAppealListData(1);
  }

  /**
   * @description 获取申诉列表数据
   *
   **/
  getAppealListData = async (
    pageNo: number,
    pageSize?: number,
    caseStatus?: string | number
  ) => {
    const templateId = getQueryString("templateId");
    const appealStatus = caseStatus ? caseStatus : this.state.caseStatus;
    const size = pageSize ? pageSize : this.state.pageSize;
    const params = {
      templateId,
      appealStatus,
      pageNo,
      pageSize: size,
    };
    const result = await fetchAppealListData(params);
    if (result) {
      if (result.code === 0) {
        const { dataList, totalCount } = result.data;
        this.setState({
          appealListData: dataList,
          // pageNo,
          totalCount,
          error: false,
        });
      } else {
        message.info(result.msg);
        this.setState({
          error: true,
        });
      }
      this.setState({
        loading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 获取处罚配置数据
   *
   **/
  getPageConfigData = async () => {
    const templateId = getQueryString("templateId");
    const result = await fetchPageConfigData(templateId);
    if (result) {
      if (result.code === 0) {
        const { displayControl } = result.data;
        this.setState({
          displayControl,
        });
      } else {
        message.info(result.msg);
      }
      this.setState({
        configLoading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 选择状态查询
   *
   **/
  getCaseStatus = async (caseStatus: string | number) => {
    await this.setState({
      caseStatus,
    });
    this.getAppealListData(1, 10, caseStatus);
  };

  /**
   * @description 获取状态
   *
   **/
  handleSelect = (value, caseStatus) => {
    burying(
      "2",
      "filter-appeal-record",
      `status=${caseStatus.key}$valid=1`,
      "ss-04",
      "undefined"
    );
    this.getCaseStatus(caseStatus.key);
  };

  /**
   * @description 分页查询
   *
   **/

  pageChange = (page: number, size: number) => {
    const { pageSize } = this.state;
    if (pageSize !== size) {
      this.setState({
        pageNo: 1,
        pageSize: size,
      });
      this.getAppealListData(1, size);
    } else {
      this.setState({
        pageNo: page,
        pageSize: size,
      });
      this.getAppealListData(page, size);
    }
  };

  /**
   * @description 跳转到详情页
   *
   **/
  linkToAppealDetails = (caseId: string | number, appealStatus: number) => {
    const templateId = getQueryString("templateId");
    this.props.history.push(
      `/case/home/detail/${caseId}?templateId=${templateId}&caseId=${caseId}&isList=1&appealStatus=${appealStatus}&allType=${getQueryString('allType') ? getQueryString('allType') : '0'}`
    );
  };

  /**
   * @description 处罚申诉tab切换
   *
   **/
  changePenaltyAppeal = () => {
    const templateId = getQueryString("templateId");
    burying(
      "2",
      "punishrecord-appeal-record",
      "undefined",
      "ss-04",
      "undefined"
    );
    this.props.history.push(`/case/home/punish/list?templateId=${templateId}`);
  };

  /**
   * @description 跳转到申诉页
   *
   **/
  linkToAppealPage = (punishId: number | string) => {
    const templateId = getQueryString("templateId");
    this.props.history.push(
      `/case/home/appealentrance?templateId=${templateId}&punishId=${punishId}`
    );
  };

  setRevokeType = () => {
    this.setState({
      modalType: !this.state.modalType,
    });
  };

  /**
   * @description 撤销
   *
   **/
  revockApplication = async () => {
    const templateId = getQueryString("templateId");
    const { caseId } = this.state;
    const params = {
      templateId,
      caseId,
    };
    const result = await revoke(params);
    if (result.code === 0) {
      this.getAppealListData(1);
      this.setRevokeType();
    }
  };

  showRevockModal = (caseId: number) => {
    this.setState({
      modalType: !this.state.modalType,
      caseId,
    });
    document.body.scrollTop = 0;
  };

  /**
   * @description 格式化时间
   *
   **/
  renderTime = (punishTime) => {
    return (
      <Fragment>
        <span className={styles.date}>
          {Moment(punishTime).format("YYYY-MM-DD")}
        </span>
        {/* <span className={styles.time}>
          {Moment(punishTime).format("HH:mm")}
        </span> */}
      </Fragment>
    );
  };

  render() {
    const {
      appealListData,
      totalCount,
      displayControl,
      modalType,
      error,
      loading,
      configLoading,
      pageNo,
    } = this.state;
    const templateId = getQueryString("templateId");
    return (
      <Fragment>
        {modalType ? (
          <div className={styles.modal}>
            <Bounced
              cancelBounced={this.setRevokeType}
              confirm={this.revockApplication}
              bouncedText="撤销申诉，审核将中止确认撤销后，您可重新提交申诉"
              buttonLeft="取消"
              buttonRight="确认撤销申请"
            />
          </div>
        ) : null}
        <div style={{ width: templateId === "2" ? "" : "815px" }}>
          <div className={styles.appeal}>
            <div className={styles.header}>
              {displayControl.need_casePunishList === 1 && getQueryString('allType') !== '1' ? (
                <Fragment>
                  <span
                    className={styles.disActive}
                    onClick={this.changePenaltyAppeal}
                  >
                    处罚记录
                  </span>
                  <span className={styles.active}>申诉记录</span>
                </Fragment>
              ) : (
                <span className={styles.active}>申诉记录</span>
              )}
            </div>

            {loading || configLoading ? (
              <Loading />
            ) : (
              <div className={styles.appealList}>
                <div className={styles.conditionMenu}>
                  <Select
                    style={{ width: "30%" }}
                    defaultValue={"选择状态"}
                    onSelect={this.handleSelect}
                  >
                    <Select.Option value="不限" key="">
                      不限
                    </Select.Option>
                    {caseType.map((item) => {
                      return (
                        <Select.Option value={item.name} key={item.id}>
                          {item.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </div>
                <ul className={styles.appealTable}>
                  <div className={styles.appealListTitle}>
                    <span className={styles.singleAppealment}>申诉单</span>
                    <span className={styles.appealReason}>申诉理由</span>
                    <span className={styles.pappealmentDate}>申诉日期</span>
                    <span className={styles.appealmentState}>申诉状态</span>
                    <span className={styles.operation}>操作</span>
                  </div>
                  {error ? (
                    <Prompt
                      path="//j1.58cdn.com.cn/arthurupload/arthurlocalpush/ysk/icon500.png"
                      tip={"系统维护中，请稍等~"}
                    />
                  ) : appealListData && appealListData.length > 0 ? (
                    appealListData.map(
                      (item: appealListType, index: number) => {
                        const {
                          caseId,
                          punishNames,
                          caseReason,
                          caseTime,
                          appealStatus,
                          punishId,
                          illegalType,
                          caseTypeName,
                        } = item;
                        const isWeiliaoPunish = punishNames[0] === '微聊禁言'
                        return (
                          <li className={styles.appealmentRecord} key={index}>
                            <div className={styles.singleAppealmentContent}>
                              <img className={styles.appealImg} src={appeal} />
                              <div className={styles.appealInfo}>
                                <span>申诉编号：{caseId}</span>

                                {getQueryString('allType') === '1' ?
                                  <span>申诉类型: {caseTypeName}</span> :
                                  <>
                                    <span className={styles.punishNames}>
                                      处罚方式：
                                      {punishNames &&
                                        punishNames.map(
                                          (item: string, index: number) => {
                                            return (
                                              <i key={index}>
                                                {item}
                                                {index !== punishNames.length - 1
                                                  ? ","
                                                  : ""}
                                              </i>
                                            );
                                          }
                                        )}
                                    </span>
                                    {!isWeiliaoPunish && <span>处罚编号：{punishId}</span>}
                                  </>}
                              </div>
                            </div>
                            <div className={styles.appealReasonContent}>
                              <div
                                className={styles.reasonContent}
                                style={{ WebkitBoxOrient: "vertical" }}
                              >
                                {caseReason}
                              </div>
                            </div>
                            <div className={styles.appealmentDateContent}>
                              {this.renderTime(caseTime)}
                            </div>
                            <div className={styles.appealmentStateContent}>
                              {appealStatus === 1 ? (
                                <i className={styles.firstState}>审核中</i>
                              ) : appealStatus === 2 ? (
                                <i className={styles.secondState}>已撤诉</i>
                              ) : appealStatus === 3 ? (
                                <i className={styles.thirdState}>待补充资料</i>
                              ) : appealStatus === 4 ? (
                                <i className={styles.fouthState}>已通过</i>
                              ) : appealStatus === 5 ? (
                                <i className={styles.fiveState}>已驳回</i>
                              ) : null}
                            </div>
                            <div className={styles.operationContent}>
                              <span
                                onClick={() => {
                                  burying(
                                    "2",
                                    "detail-appeal-record",
                                    `appealid=${caseId}`,
                                    "ss-04",
                                    "undefined"
                                  );
                                  this.linkToAppealDetails(
                                    caseId,
                                    appealStatus,
                                  );
                                }}
                              >
                                申诉详情
                              </span>
                              {appealStatus === 1 && illegalType != 2 ? (
                                <span
                                  onClick={() => {
                                    burying(
                                      "2",
                                      "revoke-appeal-record",
                                      `button=0$appealid=${caseId}`,
                                      "ss-04",
                                      "undefined"
                                    );
                                    this.showRevockModal(caseId);
                                  }}
                                >
                                  撤销申诉
                                </span>
                              ) : null}
                              {appealStatus === 3 ? (
                                <span
                                  onClick={() => {
                                    burying(
                                      "2",
                                      "revoke-appeal-record",
                                      `button=2$appealid=${caseId}`,
                                      "ss-04",
                                      "undefined"
                                    );
                                    this.linkToAppealDetails(
                                      caseId,
                                      appealStatus
                                    );
                                  }}
                                >
                                  补充资料
                                </span>
                              ) : null}
                            </div>
                          </li>
                        );
                      }
                    )
                  ) : (
                    <Prompt
                      path="//j1.58cdn.com.cn/arthurupload/arthurlocalpush/ysk/empty.png"
                      tip={"近一年内，未查到您有申诉记录。要继续保持哦～"}
                    />
                  )}
                </ul>
                {appealListData && appealListData.length > 0 && !error ? (
                  <div className={styles.pagination}>
                    <Pagination
                      current={pageNo}
                      defaultCurrent={1}
                      size="small"
                      total={totalCount}
                      onChange={this.pageChange}
                    />
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(AppealList);
